import { render, staticRenderFns } from "./PatologieComponent.vue?vue&type=template&id=473b6f1e"
import script from "./PatologieComponent.vue?vue&type=script&lang=js"
export * from "./PatologieComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports